import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import translateService from '../service/translate.service';

export interface TranslateParams<T> {
  obj: T;
  from: string;
  to: string[];
}

export const translateObject = createAsyncThunk(
  'translate/translateObject',
  async (params: TranslateParams<unknown>): Promise<unknown> => {
    return await translateService.translateObject(
      params.obj,
      params.from,
      params.to
    );
  }
);

interface TranslateState<T> {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  obj: T | null;
  error: string | null;
}

const initialState: TranslateState<unknown> = {
  status: 'idle',
  obj: null,
  error: null,
};

const translateSlice = createSlice({
  name: 'translateSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(translateObject.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        translateObject.fulfilled,
        (state, action: PayloadAction<unknown>) => {
          state.status = 'succeeded';
          state.obj = action.payload;
        }
      )
      .addCase(translateObject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default translateSlice.reducer;
